import { Link } from "react-router-dom";
import { FlaskConical, Facebook, Instagram } from "lucide-react";

const TikTokIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
  </svg>
);

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#050505]">
      <div className="mx-auto max-w-7xl px-6 py-16">
        <div className="grid gap-12 md:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <FlaskConical className="h-5 w-5 text-[#00ff72]" />
              <span className="font-mono text-xs tracking-[0.25em] text-[#F9F6F0]">
                SFH BIOHEALTH <span className="text-[#00ff72]">&amp; WELLNESS</span>
              </span>
            </div>
            <p className="mt-4 max-w-xs text-xs leading-relaxed text-[#666666]">
              Laboratory-grade research peptides. Synthesized, tested and documented to the highest
              standard in the industry.
            </p>
            <p className="mt-4 font-mono text-[10px] tracking-widest text-[#666666]">
              4201 NESHAMINY BLVD #273<br />
              BENSALEM, PA 19020
            </p>
          </div>
          <div>
            <p className="font-mono text-[10px] tracking-[0.3em] text-[#A3A3A3]">CATALOG</p>
            <ul className="mt-4 space-y-2 text-sm text-[#666666]">
              <li><Link data-testid="footer-catalog-link" to="/products" className="transition-colors hover:text-[#00ff72]">All Products</Link></li>
              <li><Link data-testid="footer-recovery-link" to="/products?category=Recovery" className="transition-colors hover:text-[#00ff72]">Recovery</Link></li>
              <li><Link data-testid="footer-growth-link" to="/products?category=Growth" className="transition-colors hover:text-[#00ff72]">Growth</Link></li>
              <li><Link data-testid="footer-metabolic-link" to="/products?category=Metabolic" className="transition-colors hover:text-[#00ff72]">Metabolic</Link></li>
            </ul>
          </div>
          <div>
            <p className="font-mono text-[10px] tracking-[0.3em] text-[#A3A3A3]">POLICIES</p>
            <ul className="mt-4 space-y-2 text-sm text-[#666666]">
              <li><Link data-testid="footer-terms-link" to="/terms" className="transition-colors hover:text-[#00ff72]">Terms of Service</Link></li>
              <li><Link data-testid="footer-privacy-link" to="/privacy" className="transition-colors hover:text-[#00ff72]">Privacy Policy</Link></li>
              <li><Link data-testid="footer-shipping-link" to="/shipping" className="transition-colors hover:text-[#00ff72]">Shipping Policy</Link></li>
              <li><Link data-testid="footer-refunds-link" to="/refunds" className="transition-colors hover:text-[#00ff72]">Refund &amp; Return Policy</Link></li>
            </ul>
          </div>
          <div>
            <p className="font-mono text-[10px] tracking-[0.3em] text-[#A3A3A3]">CONTACT</p>
            <ul className="mt-4 space-y-2 font-mono text-xs text-[#666666]">
              <li>info@sfhbiohealthandwellness.com</li>
              <li>+1 (215) 281-8195</li>
              <li>MON—FRI / 09:00—17:00 EST</li>
            </ul>
            <div className="mt-5 flex gap-3">
              <a
                href="https://www.facebook.com/p/SFH-Biohealth-and-Wellness-61580573643723/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook-link"
                className="flex h-10 w-10 items-center justify-center border border-white/15 text-[#A3A3A3] transition-colors hover:border-[#00ff72] hover:text-[#00ff72]"
              >
                <Facebook className="h-4 w-4" />
              </a>
              <a
                href="https://www.instagram.com/sfh_biohealth_and_wellness/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                className="flex h-10 w-10 items-center justify-center border border-white/15 text-[#A3A3A3] transition-colors hover:border-[#00ff72] hover:text-[#00ff72]"
              >
                <Instagram className="h-4 w-4" />
              </a>
              <a
                href="https://www.tiktok.com/@sfh_biohealth_wellness"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-tiktok-link"
                className="flex h-10 w-10 items-center justify-center border border-white/15 text-[#A3A3A3] transition-colors hover:border-[#00ff72] hover:text-[#00ff72]"
              >
                <TikTokIcon className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-6 py-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-mono text-[10px] tracking-[0.2em] text-red-400/80">
            FOR RESEARCH USE ONLY — NOT FOR HUMAN CONSUMPTION
          </p>
          <p className="font-mono text-[10px] tracking-[0.2em] text-[#666666]">
            &copy; 2026 SFH BIOHEALTH &amp; WELLNESS
          </p>
        </div>
      </div>
    </footer>
  );
}
